"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.removeFile = exports.fileSelectedStyles = exports["default"] = exports.NoFileSelected = exports.FileUpload = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InsertDriveFile = _interopRequireDefault(require("@material-ui/icons/InsertDriveFile"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _useFormState2 = _interopRequireDefault(require("../hooks/useFormState"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _forms = require("../utils/forms");

var _Grid = _interopRequireDefault(require("../Grid"));

var _FormHelperText = _interopRequireDefault(require("../FormHelperText"));

var _excluded = ["uploading", "fileData", "required", "disabled", "dataQa", "icon", "inputProps"];

var styles = function styles(theme) {
  return {
    root: {
      width: '100%'
    },
    wrapper: {
      backgroundColor: function backgroundColor(props) {
        return props.error ? (0, _colorManipulator.alpha)(theme.palette.error.main, 0.06) : theme.palette.grey[50];
      },
      border: function border(props) {
        return props.error ? '1px dashed #D32F2F' : '1px dashed #757575';
      },
      padding: theme.spacing(1.5, 2, 1.5, 1.625)
    },
    button: {
      background: theme.palette.common.white,
      border: "1px solid ".concat(theme.palette.primary.main),
      borderRadius: '6px',
      letterSpacing: '1.25px',
      lineHeight: '24px',
      textAlign: 'center',
      color: theme.palette.primary.main
    },
    icon: {
      margin: 0,
      color: theme.palette.secondary.main,
      maxHeight: '21px'
    },
    caption: {
      color: theme.palette.text.secondary
    },
    loadingWrapper: {
      display: 'inline-block',
      margin: theme.spacing(0.25, 0.25, 0, 0),
      padding: 0
    },
    helperText: {
      marginLeft: theme.spacing(2)
    },
    selectedFileName: {
      fontSize: theme.spacing(1.625),
      margin: theme.spacing(0.25, 1, 0, 1),
      position: 'absolute'
    },
    helperTextContainer: {
      minHeight: theme.spacing(1)
    },
    removeFile: {
      border: 0,
      color: theme.palette.error.main,
      background: 'transparent',
      padding: 0,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    removeFileIcon: {
      fontSize: theme.spacing(3)
    }
  };
};

exports.styles = styles;

var fileSelectedStyles = function fileSelectedStyles(theme) {
  return {
    fileName: {
      fontSize: theme.spacing(1.625),
      margin: theme.spacing(0, 1, 0, 3.5),
      lineHeight: 0
    },
    icon: {
      position: 'absolute',
      fontSize: theme.spacing(3)
    }
  };
};

exports.fileSelectedStyles = fileSelectedStyles;
var useStyles = (0, _makeStyles["default"])(styles);
var useFileSelectedStyles = (0, _makeStyles["default"])(fileSelectedStyles);

var removeFile = function removeFile(cb) {
  return function (e) {
    e.preventDefault();
    cb(null);
  };
};

exports.removeFile = removeFile;

var FileSelected = function FileSelected(_ref) {
  var name = _ref.name;
  var classes = useFileSelectedStyles();
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: true
  }, /*#__PURE__*/_react["default"].createElement(_InsertDriveFile["default"], {
    className: classes.icon
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.fileName
  }, name));
};

var NoFileSelected = function NoFileSelected(props) {
  var required = props.required,
      name = props.name,
      dataQa = props.dataQa,
      disabled = props.disabled,
      _onChange = props.onChange,
      _onBlur = props.onBlur,
      inputProps = props.inputProps,
      helpers = props.helpers;
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: true
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    required: required,
    name: name,
    type: "file",
    "data-qa": dataQa,
    disabled: disabled,
    onChange: function onChange(event) {
      _onChange && _onChange(event, event.target.files[0]);
      helpers.setValue(event.target.files[0]);
    },
    onBlur: function onBlur(ev) {
      return (0, _forms.trackOnBlur)(ev, _onBlur, name);
    }
  }, inputProps)));
};

exports.NoFileSelected = NoFileSelected;

var FileUpload = function FileUpload(_ref2) {
  var _ref2$uploading = _ref2.uploading,
      uploading = _ref2$uploading === void 0 ? false : _ref2$uploading,
      fileData = _ref2.fileData,
      required = _ref2.required,
      disabled = _ref2.disabled,
      dataQa = _ref2.dataQa,
      icon = _ref2.icon,
      inputProps = _ref2.inputProps,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);

  var _useFormState = (0, _useFormState2["default"])((0, _extends2["default"])({}, props, {
    value: fileData
  })),
      value = _useFormState.value,
      onBlur = _useFormState.onBlur,
      name = _useFormState.name,
      onChange = _useFormState.onChange,
      helperText = _useFormState.helperText,
      error = _useFormState.error,
      helpers = _useFormState.helpers;

  var classes = useStyles({
    error: error
  });
  var noFileSelected = !value;
  var showCompIcon = undefined !== icon && noFileSelected;
  var showLoadingWheel = !noFileSelected && true === uploading;
  var showRemoveFileIcon = !noFileSelected && false === uploading;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: "row",
    className: classes.wrapper,
    justify: "space-between"
  }, value && /*#__PURE__*/_react["default"].createElement(FileSelected, {
    className: classes.selectedFileName,
    name: value.name
  }), noFileSelected && /*#__PURE__*/_react["default"].createElement(NoFileSelected, (0, _extends2["default"])({}, props, {
    onBlur: onBlur,
    onChange: onChange,
    helpers: helpers
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    className: classes.icon,
    "data-qa": "".concat(name, "-icon")
  }, showCompIcon && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, icon), showLoadingWheel && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.loadingWrapper,
    "data-qa": "".concat(name, "-loading")
  }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    size: 18
  })), showRemoveFileIcon && /*#__PURE__*/_react["default"].createElement("button", {
    onClick: removeFile(helpers.setValue),
    "data-qa": "".concat(name, "-remove-file"),
    className: classes.removeFile
  }, /*#__PURE__*/_react["default"].createElement(_Clear["default"], {
    className: classes.removeFileIcon
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.helperText
  }, /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
    dataQa: "".concat(name, "-helper-text"),
    error: error
  }, helperText)));
};

exports.FileUpload = FileUpload;
FileUpload.propTypes = {
  /** Object of the fileData for file element */
  fileData: _propTypes["default"].object,

  /** Key/value pair of extra props to render on the input component */
  inputProps: _propTypes["default"].object,

  /** Selector for QA */
  dataQa: _propTypes["default"].string.isRequired,

  /** The identifier for this component. Required for testing and screen-readers. */
  id: _propTypes["default"].string,

  /** Name of the input. */
  name: _propTypes["default"].string,

  /** If `true`, this field has an error. */
  error: _propTypes["default"].bool,

  /** If `true`, this field is required. */
  required: _propTypes["default"].bool,

  /** If `true`, this field will be disabled */
  disabled: _propTypes["default"].bool,

  /** Text beneath the field used to prompt or to indicate errors. */
  helperText: _propTypes["default"].node,

  /**
   * Callback fired when the component is changed.
   *
   * **Signature:**
   * ```
   * function(event: object) => void
   * ```
   * *event*: The event source of the callback.
   */
  onChange: _propTypes["default"].func,

  /**
   * Callback fired when the component is unfocused.
   *
   * **Signature:**
   * ```
   * function(event: object) => void
   * ```
   * *event*: The event source of the callback.
   */
  onBlur: _propTypes["default"].func,

  /** If available, will render in far right of container */
  icon: _propTypes["default"].node
};
FileUpload.defaultProps = {
  type: 'file',
  value: '',
  error: false,
  required: false,
  disabled: false
};
var _default = FileUpload;
exports["default"] = _default;